const toggleMenu = document.getElementsByClassName('js_toggleMobileMenu')[0];
if (toggleMenu) {
  toggleMenu.onclick = function openMenu() {
    document.body.classList.toggle('vx_hasOpenNav');
  };
}
